import { isNotDefined } from '@sgme/fp';
import deepEqual from 'fast-deep-equal';
import { createContext, use, useCallback } from 'react';

import { useAppSelector } from '@/store/hooks.ts';
import type { FxOption } from '@/store/option/state.ts';
import type { AppState } from '@/store/store.ts';

export const OptionContext = createContext<string>('');

export function useOptionSelector<T>(selector: (option: FxOption, state: AppState) => T): T {
  const tileId = use(OptionContext);
  if (isNotDefined(tileId)) {
    throw new Error('Could not find tileId');
  }
  // oxlint-disable-next-line exhaustive-deps -- selector is intentionally locked to its first value for a stable reference
  const select = useCallback(selector, []);

  const selectorMemo = useCallback(
    (state: AppState): T => {
      const option = state.option[tileId];
      if (isNotDefined(option)) {
        throw new Error(`Could not find option with tileId ${tileId}`);
      }
      return select(option, state);
    },
    [select, tileId],
  );

  return useAppSelector(selectorMemo, deepEqual);
}
